/**
 * 模块接口
 */
import { get, post } from '@http/request'

export const workOrderPage = (params) => post(`/vip/workOrder/page`, params)
export const workOrderAdd = (params) => post(`/vip/workOrder/add`, params)
export const workOrderDetail = (params) => get(`/vip/workOrder/detail`, params)
export const workOrderCheckByWaybill = (params) => get(`/vip/workOrder/checkByWaybill`, params)
export const workOrderFirstType = (params) => get(`/vip/workOrder/firstType`, params)
export const workOrderSecondType = (params) => get(`/vip/workOrder/secondType`, params)
